module.exports = __webpack_public_path__ + "img/1-21022310045D55.06ddf465.jpeg";